var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-block__top"},[_c('h1',{staticClass:"section-block__header"},[_vm._t("header")],2),(_vm.isTopRightPopulated)?_c('div',{staticClass:"section-block__top-right"},[_vm._t("top-right")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }